import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";
import { cva } from "class-variance-authority";
import { useApp } from "~/core/store";
import Popup from "./Popup";
import { BaseMobileDropdownChoice, MobileDropdownProps } from "./interfaces";
import cn from "classnames";

export const buttonVariants = cva(
    "block w-full border text-left disabled:bg-gray-100 break-all",
    {
        variants: {
            variant: {
                compact: "min-h-[26px] rounded border-gray-200 pl-4",
                classic:
                    "min-h-[32px] rounded-3xl border-gray-300 px-4 py-1 outline-none",
                flat: "min-h-[32px] rounded-3xl border-gray-300 px-4 py-1 outline-none",
            },
        },
        defaultVariants: {
            variant: "compact",
        },
    },
);

const MobileDropdown = <Row extends BaseMobileDropdownChoice>({
    choices,
    value,
    onChange,
    onExpand,
    renderLabel = (choice) => choice?.id.toString() ?? "",
    renderOption,
    placeholder = "Select an option",
    maxSuggestions, // @TODO: use or remove
    className,
    inputClassName,
    disabled,
    variant,
}: MobileDropdownProps<Row>) => {
    // @TODO: consider moving to organism level as it depends on mobile slice
    //
    const {
        mobile: { registerDropdown },
    } = useApp();
    const show = useSignal(false);
    const rect = useSignal<DOMRect | null>(null);

    useEffect(() => registerDropdown(show), [show, registerDropdown]);

    return (
        <div className={cn("flex w-full items-center", className)}>
            <Popup
                choices={choices}
                value={value}
                onChange={(value) => {
                    onChange(value);
                    show.value = false;
                }}
                onClose={() => {
                    show.value = false;
                }}
                onExpand={onExpand}
                renderOption={renderOption}
                maxSuggestions={maxSuggestions}
                show={show}
                buttonRect={rect}
                variant={variant}
            />
            <button
                type="button"
                disabled={disabled}
                onClick={({ currentTarget }) => {
                    rect.value = currentTarget.getBoundingClientRect();
                    show.value = true;
                }}
                className={buttonVariants({
                    variant,
                    className: inputClassName,
                })}
            >
                {value ? (
                    renderLabel(value)
                ) : (
                    <span className="text-gray-500">{placeholder}</span>
                )}
            </button>
        </div>
    );
};

export default MobileDropdown;
